import { ReportMoney } from "../components-layout/Logos"

export default function DatagridCierreCajas({ data, dFecha, aFecha, recordsPerPage, currentPage, sede }) {

  return (
    <div className="px-4 sm:px-6 lg:px-8 bg-primarioMira pt-5 rounded-lg shadow-xl">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <div className="flex flex-row">
            <ReportMoney
              className="h-14 w-14 mr-2 text-secundario"
            />
            <div>
              <h3 className="text-lg font-semibold text-white">Detalle - Cierre de Caja / Efectivo {window.location.pathname === '/campus/cierre_caja' || window.location.pathname === '/campus/' ? '' : ' / Sede ' + sede}</h3>
              <h4 className="text-lg font-semibold text-white">De {dFecha} a {aFecha}</h4>
            </div>
          </div>
          <p className="mt-2 text-sm text-grisMira">
            Lista detallada cierre de caja por usuario.
          </p>
        </div>
      </div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full align-middle">
            <div className="h-auto shadow ring-1 ring-black ring-opacity-5">
              <table className="min-w-full divide-y divide-grisMira p-5">
                <thead className="sticky top-0 bg-secundarioMira">
                  <tr className="divide-x divide-grisMira">
                    <th scope="col" className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-grisMira sm:pl-6">
                      ID
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Usuario
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Días de retraso
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Campus
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Fecha
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Empresa
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Efectivo
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Total depositado
                    </th>
                    <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      Fecha realizado
                    </th>
                    <th scope="col" className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-white sm:pr-6">
                      Efectividad
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-grisMira bg-primarioMira">
                  {data?.map((x, index) => {
                    console.log(x)
                    let color
                    if (x.EfectivoCobrado === x.EfectivoDepositado) {
                      color = 'bg-primarioMira'
                    } else if ((x.EfectivoCobrado !== x.EfectivoDepositado) && (x.DiasSinCuadrar === 0)) {
                      color = 'bg-green-500/80'
                    } else if ((x.EfectivoCobrado !== x.EfectivoDepositado) && (x.DiasSinCuadrar === 1)) {
                      color = 'bg-yellow-500/80'
                    } else if ((x.EfectivoCobrado !== x.EfectivoDepositado) && (x.DiasSinCuadrar === 2)) {
                      color = 'bg-orange-500/80'
                    } else if ((x.EfectivoCobrado !== x.EfectivoDepositado) && (x.DiasSinCuadrar > 2)) {
                      color = 'bg-red-500/80'
                    }

                    return (
                      <tr key={900 + index} className='divide-x divide-grisMira'>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium sm:pl-6 text-grisMira'>
                          {(index + 1) + (recordsPerPage * (currentPage - 1))}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          <p className={`${color} rounded-xl mx-auto text-center py-1 px-2 text-sm`}>
                            {x.Usuario}
                          </p>
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          <p className={`${color} rounded-xl mx-auto text-center py-1 px-2 text-sm`}>
                            {x.DiasSinCuadrar}
                          </p>
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          {x.Sede}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          <p className={`${color} rounded-xl mx-auto text-center py-1 px-2 text-sm`}>
                            {x.FechaCorte}
                          </p>
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          {x.Empresa}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(x.EfectivoCobrado)}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(x.EfectivoDepositado)}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                          {x.FechaCuadrado}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm text-white sm:pr-6'>
                          {x.DiasParaCuadrar}
                        </td>
                      </tr>
                    )
                  }
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
